import axios from 'axios';
import i18n from '../i18n';

export function getApiErrorMessage(
  error: unknown,
  fallbackKey = 'Произошла ошибка при обращении к серверу',
): string {
  if (!axios.isAxiosError(error)) {
    return i18n.t(fallbackKey);
  }

  if (!error.response) {
    if (error.code === 'ECONNABORTED') {
      return i18n.t('Превышено время ожидания. Попробуйте снова.');
    }
    if (error.code === 'OFFLINE_NOT_SUPPORTED') {
      return error.message;
    }
    if (error.code === 'OFFLINE_CACHE_MISS' || error.message === 'offline_cache_miss') {
      return i18n.t('Данные недоступны офлайн. Подключитесь к сети или дождитесь первой загрузки.');
    }
    return i18n.t('Нет подключения к интернету. Проверьте сеть и попробуйте снова.');
  }

  const { status, data } = error.response;
  const serverMessage =
    typeof data === 'object' && data !== null && 'message' in data
      ? (data as { message?: unknown }).message
      : undefined;

  if (status >= 500) {
    return i18n.t('Сервер временно недоступен. Попробуйте позже.');
  }

  if (typeof serverMessage === 'string' && serverMessage.trim()) {
    return serverMessage;
  }

  return i18n.t(fallbackKey);
}
